// src/pages/Evento/EventoKidsGerenciarPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import EventoKidsGerenciar from './EventoKidsGerenciar';
import { Box, Typography } from '@mui/material';

const EventoKidsGerenciarPage = () => {
  const { id } = useParams();

  return (
    <Box p={2} sx={{ bgcolor: '#f4f6f8', minHeight: '100vh' }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Gestão em Tempo Real dos Kids
      </Typography>
      <EventoKidsGerenciar eventoId={id} />
    </Box>
  );
};

export default EventoKidsGerenciarPage;
